"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextStep = void 0;
var getWizardStrategy_1 = require("./dependencies/getWizardStrategy");
var isStepLastOfLasts_1 = require("./dependencies/isStepLastOfLasts");
var getNextStep_1 = require("./dependencies/getNextStep");
var nextStep = function (history, setHistory) { return function (currentStep, options) { return function () {
    var wizardStrategy = getWizardStrategy_1.getWizardStrategy(options);
    if (wizardStrategy === "simple") {
        return setHistory(function (ps) { return __spreadArrays(ps, [ps[ps.length - 1] + 1]); });
    }
    if (isStepLastOfLasts_1.isStepLastOfLasts(options, history[history.length - 1])) {
        return console.log("Wizard: impossible to process to next step, step is already last");
    }
    setHistory(function (ps) { return __spreadArrays(ps, [getNextStep_1.getNextStep(history[history.length - 1], options)]); });
}; }; };
exports.nextStep = nextStep;
//# sourceMappingURL=nextStep.js.map